
class fetchHelper {
    urls = {}
    endpoint = '';
    setLoadingIndicator = null;
    message = null;



    setData(key, value) {
        this[key] = value;
        console.log(key, value);
    }

    getData = async (key, refresh = false, loading = true) => {
        try {
            this.setLoadingIndicator(loading);
            var path = this.urls.getUrls[key]

            var options = {
                method: "get",
                mode: 'cors',
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json",
                    // "Authorization": Authorization
                },
            }



            // for dnearby
            var res = await fetch(
                `${this.endpoint}${path}`,
                options,

            );
            // return console.log(res)
            var status = res.status
            res = await res.json();
            this.setLoadingIndicator(false);

            return { status, res };


        } catch (error) {
            console.log(error)
        }

    }

    filterData = async (key, obj, refresh = false, loading = true) => {
        try {
            console.log(obj)
            this.setLoadingIndicator(loading);

            var path = this.urls.getUrls[key]
            if (!path) {
                throw new Error('No path found for key: ' + key);
            }
            var str = '?'
            for (var k in obj) {
                console.log(obj[k])
                if (obj[k] == "") { continue }
                if (!obj[k]) { continue }
                str = str + k + "=" + obj[k] + "&"
            }
            path += str
            console.log(path)
            var options = {
                method: "get",

                credentials: 'include',
                headers: {
                    "Content-Type": "application/json",
                    // "Authorization": Authorization
                },
            }

            var res = await fetch(
                `${this.endpoint}${path}`,
                options,

            );
            var status = res.status
            res = await res.json();
            this.setLoadingIndicator(false);
            return { status, res };

        } catch (error) {
            console.log(error)
        }

    }


    createData = async (obj, key, returnVal = false, loading = true) => {
        try {
            this.setLoadingIndicator(loading);
            var path = this.urls.postUrls[key];
            if (!path) {
                throw new Error('No path found for key: ' + key);
            }
            var raw = obj
            console.log(raw, JSON.stringify(raw))
            var res = await fetch(
                `${this.endpoint}${path}`,
                {
                    method: "post",
                    mode: 'cors',
                    credentials: 'include',
                    headers: {
                        "Content-Type": "application/json",
                        // "Authorization": Authorization
                    },
                    body: JSON.stringify(raw),
                    redirect: 'follow'

                },

            );
            var status = res.status;
            // console.log(res)
            var contentType = res.headers.get("content-type");
            if (contentType && contentType.indexOf('application/json') !== -1) {
                res = await res.json();
            }
            if (status == 200) {
                // message.success(key + " Created Successfully")
                // this.getData(key)
            } else {
                this.message.error("Oops! something went wrong. Try again later.")
            }
            this.setLoadingIndicator(false);

            return { status, res }
        } catch (error) {
            console.log(error)
        }
    }



    updateData = async (obj, key, loading = true) => {
        try {
            this.setLoadingIndicator(loading);

            var path = this.urls.putUrls[key];
            if (!path) {
                throw new Error('No path found for key: ' + key);
            }
            var raw = {
                ...obj
            }
            console.log(raw, JSON.stringify(raw))
            var res = await fetch(
                `${this.endpoint}${path}`,
                {
                    method: "put",
                    mode: 'cors',
                    credentials: 'include',
                    headers: {
                        "Content-Type": "application/json",
                        // "Authorization": Authorization
                    },
                    body: JSON.stringify(raw),
                    redirect: 'follow'

                },

            );
            var status = res.status;
            res = await res.json();
            console.log(res);
            if (status == 200) {
                this.message.success(key + " Updated Successfully")
                this.getData(key)
            } else {
                this.message.error("Oops! something went wrong. Try again later.")
            }
            this.setLoadingIndicator(false);

            return { status, res };
        } catch (error) {
            console.log(error)
        }


    }




}



const helper = new fetchHelper();
export default helper;